import { useEffect, useState } from 'react';
import { Heading } from 'react-aria-components';

import { useI18n } from 'context/i18n';
import { GIFT_BAG_BASE } from 'utils/constants/products';
import { useLocale } from 'hooks';
import { interpolate } from 'utils/string';
import { getDomainValue } from 'utils/domain';
import { formatPrice } from 'utils/price';

import { Dialog, DialogRoot, DialogX } from 'components/ui/dialog';

export function GiftBagModal() {
  const { t, profileData } = useI18n();
  const { country, isoLocale } = useLocale();

  const [isOpen, setIsOpen] = useState(false);
  const [specificSku, setSpecificSku] = useState<string | null>(null);

  const formattedAmount = formatPrice({
    amount: profileData?.gwpover,
    currency: profileData?.currency,
    currencyCode: profileData?.currencySap,
    isoLocale,
    options: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  });

  useEffect(() => {
    window.showGiftBagPopUp = (sku?: string) => {
      setIsOpen(true);

      if (sku) {
        setSpecificSku(sku);
      }
    };
    return () => {
      window.showGiftBagPopUp = undefined;
    };
  }, []);

  const specificSkuComponent = (
    <div className="sm:max-w-[350px] nnormal:sm:max-w-[280px]">
      <picture>
        <img src={`${GIFT_BAG_BASE}/${specificSku}.jpg`} alt={'Image of gift Bag photo'} width={'100%'} height={'100%'} className="object-cover" />
      </picture>
    </div>
  );

  const skuGiftPurchaseComponent = (
    <div className="sm:max-w-[350px]">
      <picture>
        <img
          src={`${GIFT_BAG_BASE}/${profileData?.config?.sku_gift_purchase}.jpg`}
          alt={'Image of gift Bag photo'}
          width={'100%'}
          height={'100%'}
          className="object-cover"
        />
      </picture>
    </div>
  );
  // Comprobación inline que reemplaza `hasToRenderGiftHat(t, country)`
  const giftString = t('ficha.producto', `bundle.text.${country}`);
  const renderGifHat =
    giftString !== undefined && giftString !== null && giftString !== `ficha.producto.bundle.text.${country}` && String(giftString).trim() !== '';

  return (
    <DialogRoot
      isOpen={isOpen}
      onOpenChange={(isOpen) => {
        setIsOpen(isOpen);
        setSpecificSku(null);
      }}
      showOverlay
      position="bottom-right"
    >
      <Dialog className="p-0">
        <Heading level={2} className="sr-only">
          gift-bag modal
        </Heading>
        <DialogX absolute />
        <div>
          <div id="modal-gift-content" className="flex flex-col sm:flex-row [&>div]:flex-1">
            {getDomainValue({
              camper:
                specificSku !== null ? specificSkuComponent
                : profileData?.config?.sku_gift_purchase ? skuGiftPurchaseComponent
                : null,
              camperlab: 'camper',
              nnormal:
                specificSku !== null && renderGifHat ? specificSkuComponent
                : profileData?.config?.sku_gift_purchase && renderGifHat ? skuGiftPurchaseComponent
                : null,
            })}

            <div className="flex max-w-sm flex-col items-center justify-center gap-2 p-6 pt-12 text-left only:justify-center only:text-center nnormal:text-left only:nnormal:items-start only:nnormal:text-left">
              <p className="mb-0 text-center text-3xl nnormal:text-left nnormal:font-secondary nnormal:text-base">{t('ficha.producto', 'bundle.title')}</p>
              <div
                className="nnormal:text-sm"
                dangerouslySetInnerHTML={{
                  __html: interpolate(giftString, {
                    '<GWP amount>': formattedAmount,
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </DialogRoot>
  );
}
